import React, { useState } from "react";
import { toast } from "react-toastify";

export default function LogCalculator() {
  const [perCalc, setPerCalc] = useState({ amount: null, percentage: null });
  const [perce, setPerce] = useState(null);
  const [errors, setErrors] = useState<any>({});

  const handleChange = (e) => {
    setPerce("");
    const { name, value } = e.target;
    setPerCalc({ ...perCalc, [name]: value });
    setErrors({ ...errors, [name]: "" });
  };

  const validateForm = () => {
    let formIsValid = true;
    let err = {} as any;
    if (!perCalc || !perCalc?.amount) {
      err.amount = "* Required";
      formIsValid = false;
    }
    if (!perCalc || !perCalc?.percentage) {
      err.percentage = "* Required";
      formIsValid = false;
    }
    setErrors(err);
    return formIsValid;
  };

  const handleCalculate = () => {
    if (validateForm()) {
      if (perCalc?.amount && perCalc?.percentage) {
        if (perCalc?.percentage == "e") {
          setPerce(Math.log10(perCalc?.amount) / Math.log10(2.7182818));
        } else if (perCalc?.percentage >= 0) {
          setPerce(
            Math.log10(perCalc?.amount) / Math.log10(perCalc?.percentage)
          );
        } else {
          toast.error("Enter Valid Base Value");
        }
      } else {
        if (perCalc?.amount) {
          toast.error("Enter Valid Base Value");
        } else if (perCalc?.percentage) {
          toast.error("Enter Valid head Value");
        } else {
          toast.error("Enter Valid Values");
        }
      }
    }
  };
  return (
    <div>
      <div className="children-box-alignment">
        <div className="percentage-calculator-design">
          <div className="log-grid-alignment">
            <div className="log-gridItem-alignment">
              <div className="text-grid-items ">
                <h4>log</h4>
              </div>
            </div>
            <div className="log-gridItem-alignment">
              <div className="text-grid-items">
                <div className="percentage-input small-input-alignment">
                  <span className="text-sm text-red-700">
                    {errors?.amount}
                  </span>
                  <input
                    type="number"
                    name="amount"
                    placeholder="10000"
                    onChange={(e) => {
                      Number(e.target.value) >= 0 && handleChange(e);
                    }}
                    className={errors?.amount && "error-input"}
                  />
                </div>
              </div>
              <div className="text-grid-items">
                <div className="percentage-input second-input-alignment">
                  <input
                    type="text"
                    name="percentage"
                    placeholder="10"
                    onChange={(e) => handleChange(e)}
                    className={errors?.percentage && "error-input"}
                  />
                  <span className="text-sm text-red-700">
                    {errors?.percentage}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div className="percentage-final-answer">
            <div className="text-grid-items">
              <div className="percentage-input"></div>
            </div>
          </div>
          <div className="percentage-final-answer">
            <div className="sec-grid">
              <div className="sec-grid-items">
                <div className="button">
                  <button onClick={() => handleCalculate()}>Calculate</button>
                </div>
              </div>
            </div>
          </div>
        </div>
        {perce ? (
          <div className="gst-result-box">
            <div className="text-alignment">
              <p>Answer is</p>
              <span>{perce} </span>
            </div>
          </div>
        ) : (
          <div className="gst-result-box">
            <div className="text-alignment">
              <p>Answer is</p>
              <span>0 </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
